  // breakpoint.service.ts
import { Injectable, inject } from '@angular/core';
import { BreakpointObserver } from '@angular/cdk/layout';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs/operators';

export type BootstrapBreakpoint = 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl';

const QUERIES: Record<BootstrapBreakpoint, string> = {
  xs: '(max-width: 575.98px)',
  sm: '(min-width: 576px) and (max-width: 767.98px)',
  md: '(min-width: 768px) and (max-width: 991.98px)',
  lg: '(min-width: 992px) and (max-width: 1199.98px)',
  xl: '(min-width: 1200px) and (max-width: 1399.98px)',
  xxl: '(min-width: 1400px)',
};

@Injectable({ providedIn: 'root' })
export class BreakpointService {
  private breakpointObserver = inject(BreakpointObserver);

  // Signal con el breakpoint actual, se actualiza solo en resize
  current = toSignal(
    this.breakpointObserver.observe(Object.values(QUERIES)).pipe(
      map(() => this.getCurrentBreakpoint())
    ),
    { initialValue: this.getCurrentBreakpoint() }
  );

  private getCurrentBreakpoint(): BootstrapBreakpoint {
    for (const [name, query] of Object.entries(QUERIES)) {
      if (this.breakpointObserver.isMatched(query)) {
        return name as BootstrapBreakpoint;
      }
    }
    return 'xs';
  }
}